import { AxiosResponse } from 'axios'
import { RequestREAD } from 'services/Instances'

export function ReportsCounterpartService() {
  const path = 'RelatorioContraparte'

  //Traz apenas os contratos onde o usuário é contraparte ou contraparte substituto
  const GetExcelRelatorioContraparte = async (
    competenciaInicio: string,
    competenciaFim: string,
    idUser: number
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetRelatorioContraparte`, { params: { competenciaInicio, competenciaFim, idUsuario: idUser } })

  //Traz todos os contratos. Visão analista/normativo/adm
  const GetAllRelatorioContraparte = async (
    competenciaInicio: string,
    competenciaFim: string
  ): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetAllRelatorioContraparte`, { params: { competenciaInicio, competenciaFim } })

  return {
    GetExcelRelatorioContraparte,
    GetAllRelatorioContraparte
  }
}

